export const EVENTS_OPTIONS = ['No Event', 'Javascript', 'Stop Propagation','New Variable','New Action'];

export const WIDGET_CONSTANTS = {
  //This list will be extended with variable types in baseService
  EVENTS: {
    'NO_EVENT': 'No Event',
    'JAVASCRIPT': 'Javascript',
    'STOP_PROPAGATION': 'Stop Propagation',
    'STOP_PROP_FN': '$event.stopPropagation()'
  },
  EVENTS_OPTIONS: EVENTS_OPTIONS,
  NAVIGATION_TYPE: {
    'BASIC'    : 'Basic',
    'CLASSIC'  : 'Classic',
    'ADVANCED' : 'Advanced',
    'SCROLL'   : 'Scroll',
    'INLINE'   : 'Inline',
    'PAGER'    : 'Pager',
    'ONDEMAND' : 'On-Demand'
  }
}

export const EVENTS_MAP = new Map<string, string>([
  // ['enterkeypress', 'keypress.enter']
  ['tap', 'click']
]);

export const DISPLAY_TYPE = {
  BLOCK: 'block',
  INLINE_BLOCK: 'inline-block',
  INLINE: 'inline'
};

// set of boolean attrs
const BOOLEAN_ATTRS = new Set([
  'readonly', 'autofocus', 'disabled', 'startchecked', 'multiple',
  'selected', 'required', 'controls', 'autoplay', 'loop', 'muted', 'show'
]);

/**
 * Returns true if the provided key is a boolean attribute
 * @param {string} key
 * @returns {boolean}
 */
export const isBooleanAttr = (key: string): boolean => BOOLEAN_ATTRS.has(key);

const DIMENSION_PROPS = new Set([
  'width',
  'height',
  'iconheight',
  'iconwidth',
  'popoverwidth',
  'popoverheight',
  'imagewidth',
  'imageheight'
]);

export const isDimensionProp = (key: string): boolean => DIMENSION_PROPS.has(key);

export const TOKENS_KEYS = {
  STANDARD: 'standard',
};
